import useQuery from 'hooks/useQuery'
import React, { createContext, useMemo } from 'react'
import { Outlet } from 'react-router-dom'

export const AdminDataContext = createContext({
  mediators: {},
  fetchMediators: async () => {},
  translators: {},
  fetchTranslators: async () => {},
  clients: {},
  fetchClients: async () => {},
  accounts: {},
  fetchAccounts: async () => {},
  specialities: {},
  fetchSpecialities: async () => {},
})

const AdminDataProvider = ({ children }) => {
  const { data: mediators, makeRequest: fetchMediators } = useQuery({
    defaultEndpoint: '/admins/mediators',
  })
  const { data: specialities, makeRequest: fetchSpecialities } = useQuery({
    defaultEndpoint: '/admins/specialities',
  })
  const { data: clients, makeRequest: fetchClients } = useQuery({
    defaultEndpoint: '/admins/clients',
  })
  const { data: translators, makeRequest: fetchTranslators } = useQuery({
    defaultEndpoint: '/admins/translators',
  })
  const { data: accounts, makeRequest: fetchAccounts } = useQuery({
    defaultEndpoint: '/admins/accounts',
  })

  const contextValue = useMemo(
    () => ({
      mediators: mediators?.mediators || mediators,
      fetchMediators,
      specialities: specialities?.specialities || specialities,
      fetchSpecialities,
      translators: translators?.translators || translators,
      fetchTranslators,
      clients: clients?.clients || clients,
      fetchClients,
      accounts: accounts?.accounts || accounts,
      fetchAccounts,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [mediators, specialities, clients, translators, accounts],
  )
  return (
    <AdminDataContext.Provider value={contextValue}>
      <Outlet />
    </AdminDataContext.Provider>
  )
}

export default AdminDataProvider
